import { render } from "./AssemblyImpactNote.vue?vue&type=template&id=f0423c40"
import script from "./AssemblyImpactNote.vue?vue&type=script&lang=js"
export * from "./AssemblyImpactNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__